import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './index.css';
import { Dialog, DialogContent } from '@material-ui/core';
import { Button } from '@mui/material';
import { addChannel, fetchChannels, hideCreateChannelDialog, fetchChannelInfo } from '../../../../../actions/channels';
import variables from '../../../../../utils/variables';
import UserNameTextField from './UserNameTextField';
import { avatarUpload } from '../../../../../actions/createAssets';
import { showMessage } from '../../../../../actions/snackbar';
import { getAbsoluteHash } from '../../../../../utils/ipfs';
import CircularProgress from '../../../../../components/CircularProgress';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../../../config';
import withRouter from '../../../../../components/WithRouter';

const ChannelCreationDialog = (props) => {
    const [inProgress, setInProgress] = useState(false);

    useEffect(() => {
        if (props.open) {
            const dialogs = document.querySelectorAll('.dialog:not(.create_channel_dialog)');
            dialogs.forEach((dialog) => {
                if (window.getComputedStyle(dialog).display !== 'none') {
                    dialog.setAttribute('data-was-visible', 'true');
                    dialog.style.display = 'none';
                }
            });
        } else {
            const dialogs = document.querySelectorAll('.dialog[data-was-visible="true"]');
            dialogs.forEach((dialog) => {
                dialog.style.display = '';
                dialog.removeAttribute('data-was-visible');
            });
        }
    }, [props.open]);

    const handleClick = () => {
        const data = {
            name: `${props.userName}`,
            description: `This is ${props.userName}'s channel for the community to engage on OmniFlix TV`,
            username: props.userName,
            // profilePicture: '',
            channelNFTConfig: {
                name: `${props.userName} - OmniFlix Channel NFT (v1)`,
                description: `This is the OmniFlix TV Channel NFT (v1) issued representing the channel ${props.userName}. These NFTs will be used to mirgrate to future versions 🤫`,
                profilePicture: getAbsoluteHash('ipfs://QmcJg5UnfNKzxaj41WRviUmDaoLZxoXq5UKB3MFeFHAS26'),
            },
        };

        props.addChannel(data, (result) => {
            setInProgress(true);
            if (result) {
                props.fetchChannels(DEFAULT_SKIP, DEFAULT_LIMIT, '', (cb) => {
                    if (cb) {
                        const id = cb && cb.length > 0 && cb[0] && cb[0]._id;
                        if (id) {
                            let count = 0;
                            props.fetchChannelInfo(id, (res) => {
                                if (res) {
                                    if (!props?.router?.location?.pathname.includes('mediaNode') &&
                                        !props?.router?.location?.pathname.includes('streams')) {
                                        props.router.navigate('/channel/' + id);
                                    }
                                    props.handleClose();
                                    setInProgress(false);
                                    return;
                                }

                                const fetchInfo = setInterval(() => {
                                    props.fetchChannelInfo(id, (res) => {
                                        if (res) {
                                            if (!props?.router?.location?.pathname.includes('mediaNode') &&
                                                !props?.router?.location?.pathname.includes('streams')) {
                                                props.router.navigate('/channel/' + id);
                                            }
                                            props.handleClose();
                                            setInProgress(false);
                                            clearInterval(fetchInfo);
                                        }
                                    });
                                    count += 1;
                                    if (count > 4) {
                                        if (!props?.router?.location?.pathname.includes('mediaNode') &&
                                            !props?.router?.location?.pathname.includes('streams')) {
                                            props.router.navigate('/channel/' + id);
                                        }
                                        props.handleClose();
                                        setInProgress(false);
                                        clearInterval(fetchInfo);
                                    }
                                }, 2000);
                            });
                        }
                    }
                });
            }
        });
    };

    const disable = (props.userName === '' || props.status);
    return (
        <Dialog
            disableEnforceFocus
            aria-labelledby="create-poll"
            className="dialog create_channel_dialog"
            open={props.open}
            onClose={props.handleClose}>
            <DialogContent className="dialog_content">
                {(props.inProgress || inProgress) && <CircularProgress className="full_screen"/>}
                <h2>{variables[props.lang]['create_your_channel']}</h2>
                <p>{variables[props.lang]['user_name']}</p>
                <UserNameTextField/>
                <Button
                    aria-label="create-channel" className="create_channel_button" disabled={disable}
                    onClick={handleClick}>
                    {variables[props.lang]['create_channel']}
                </Button>
            </DialogContent>
        </Dialog>
    );
};

ChannelCreationDialog.propTypes = {
    addChannel: PropTypes.func.isRequired,
    avatarUpload: PropTypes.func.isRequired,
    fetchChannelInfo: PropTypes.func.isRequired,
    fetchChannels: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    inProgress: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    showMessage: PropTypes.func.isRequired,
    status: PropTypes.bool.isRequired,
    userName: PropTypes.string.isRequired,
    router: PropTypes.shape({
        navigate: PropTypes.func.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
        }).isRequired,
    }),
};

const stateToProps = (state) => {
    return {
        open: state.channels.createChannelDialog.open,
        userName: state.channels.userName,
        lang: state.language,
        inProgress: state.channels.channelAdd.inProgress,
        status: state.channels.usernameStatus,
    };
};

const actionToProps = {
    avatarUpload,
    showMessage,
    addChannel,
    handleClose: hideCreateChannelDialog,
    fetchChannels,
    fetchChannelInfo,
};

export default withRouter(connect(stateToProps, actionToProps)(ChannelCreationDialog));
